export const environment = {
  production: false,
  functionsUrl: 'https://us-central1-wemaron-vouchers-dev.cloudfunctions.net',
};
